function posMicrosOptionsComponent(integrationConstant, integrationSettingsService) {
    const vm = this;
    vm.updateMicrosOptions = () => {
        vm.onDataUpdate({updatedData: vm.data});
    };
    vm.$onInit = () => {
        vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
        vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
    };
    vm.$onChanges = (changesObj) => {
        // Changes in the integrationData on the parent needs to be update
        vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
    };
}
angular.module('qkr.integration.settings')
    .component('posMicrosOptions', {
        template: require('./pos-micros-options.html'),
        bindings: {
            integrationData: '<',
            integrationForm: '<',
            onDataUpdate: '&'
        },
        controller: posMicrosOptionsComponent,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/pos.micros.options.component.js